import { styled } from "@mui/material";
import logoColor from "assets/icons/logoColor.png";
import logoWhite from "assets/icons/logoWhite.png";
import { hoverStyles } from "helpers/hoverStyles";
import { Link } from "react-router-dom";
import { routes } from "routes";

export interface NavBarLogoButtonProps {
	color: boolean;
}

const HoverLink = styled(Link)(({ theme }) => hoverStyles(theme));

export const NavBarLogoButton = ({
	color = true,
}: NavBarLogoButtonProps): JSX.Element => {
	return (
		<HoverLink
			to={routes.path}
			aria-label="Go to home page"
			sx={{ paddingLeft: 1, paddingRight: 1, borderRadius: 2 }}
		>
			<img src={color ? logoColor : logoWhite} alt="Science Island logo" />
		</HoverLink>
	);
};
